import { COLORS, Gradient } from '../../config/designSystem/Colors';
import { DimensionValue, View } from 'react-native';
import { GradientView } from './GradientView';
import { SPACING } from '../../config/designSystem/Spacing';

type ProgressBarPathProp = {
    readPercentage: number;
    gradient: Gradient;
}

export const HEIGHT_PROGRESS_BAR = SPACING['sp-8'];

export const GradientProgressBar = ({readPercentage, gradient}: ProgressBarPathProp) => {
  const WIDTH = `${readPercentage}%` as DimensionValue;
  return(<View
    style={{
      height: HEIGHT_PROGRESS_BAR,
      width: '100%',
      backgroundColor: COLORS.surface.secondary,
    }}
  >
    <GradientView
      gradient={gradient}
      style={{
        width: WIDTH,
        borderRadius: SPACING['sp-16'], zIndex: 3
      }}>
      <View
        style={{
          height: HEIGHT_PROGRESS_BAR,
          width:'100%'
        }}
      />
    </GradientView>
  </View>);
};